// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusHeader__container-efb82f {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.StatusHeader__title-d16524 {
  margin-top: 24px;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/StatusHeader/StatusHeader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.title {\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StatusHeader__container-efb82f`,
	"title": `StatusHeader__title-d16524`
};
module.exports = ___CSS_LOADER_EXPORT___;
